import { isRecord } from './generationValidation';
const INTENT_STORAGE_KEY = 'admin.map-generation.intent';
export function readGenerationIntent(): string | null {
  const stored = sessionStorage.getItem(INTENT_STORAGE_KEY);
  if (stored === null) return null;
  const metadata: unknown = JSON.parse(stored);
  if (!isRecord(metadata) || typeof metadata.key !== 'string' || !/^[A-Za-z0-9._:-]{1,128}$/.test(metadata.key)) throw new Error('Нельзя восстановить подтверждение запуска. Обратитесь к оператору.');
  return metadata.key;
}
export function createGenerationIntent(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  const parts = Array.from(bytes, (value) => value.toString(16).padStart(2, '0'));
  const key = `map-${parts.join('')}`;
  const metadata = JSON.stringify({ key });
  sessionStorage.setItem(INTENT_STORAGE_KEY, metadata);
  return key;
}
export function clearGenerationIntent(): void { sessionStorage.removeItem(INTENT_STORAGE_KEY); }
